import { createTheme } from "@mui/material/styles";

export const getTheme = (mode: "light" | "dark") =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: "#1976d2",
      },
      secondary: {
        main: "#9708aaff",
        dark: "#3f0244ff",
      },
      background: {
        default: mode === "light" ? "#f4f6f8" : "#121212",
        paper: mode === "light" ? "#fff" : "#1e1e1e",
        notification: mode === "light" ? "#e1edf0" : "#23272b",
        scrollbarTrack: mode === "light" ? "#f1f1f1" : "#23272b",
      },
      status: {
        awaitingApproval: "dodgerblue",
        approved: "forestgreen",
        completed: "mediumpurple",
        rejected: "crimson",
        closed: "dimgray",
        queried: "#060e0fff",
        default: "orange",
        requireReceipt: "purple",
      },
      custom: {
        scrollbarThumb: "#888",
        scrollbarThumbHover: "#555",
      },
    } as any, // allow custom keys
    typography: {
      fontFamily: "Roboto, Arial, sans-serif",
      h1: { fontWeight: 700 },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 500 },
      button: { textTransform: "none" },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
    },
  });
